import { img2, img3, img4, img5, img6, img7 } from "../../_components/Imagepath";

export default {
    Data: [
        {
          Id: 1,
          key:1,
          img:img2,
          Name: "John Smith",
          email: "john@example.com",
          Subscription: "Enterprise",
          Amount: "$650",
          Durations: "One Year",
          StartDate: "19 Dec 2022, 06:12 PM",
          EndDate: "19 Dec 2023, 06:12 PM"
        },
        {
          Id: 2,
          key:2,
          img:img3,
          Name: "Johnny",
          email: " johnny@example.com",
          Subscription: "Standard",
          Amount: "$350",
          Durations: "6 Month",
          StartDate: "15 Dec 2022, 04:35 PM",
          EndDate: "15 April 2023, 04:35 PM"
        },
        {
          Id: 3,
          key:3,
          img:img4,
          Name: "Robert",
          email: " robert@example.com",
          Subscription: "Basic",
          Amount: "$850",
          Durations: "1 Month",
          StartDate: "04 Dec 2022, 04:35 PM",
          EndDate: "05 April 2023, 04:35 PM"
        },
        {
          Id: 4,
          key:4,
          img:img5,
          Name: "Sharonda",
          email: " sharon@example.com",
          Subscription: "Enterprise",
          Amount: "$950",
          Durations: "One Year",
          StartDate: "12 Dec 2022, 04:35 PM",
          EndDate: "13 April 2023, 04:35 PM"
        },
        {
          Id: 5,
          key:5,
          img:img6,
          Name: "Pricilla",
          email: "pricilla@example.com",
          Subscription: "Standard",
          Amount: "$350",
          Durations: "1 Month",
          StartDate: "28 Nov 2022, 03:25 PM",
          EndDate: "28 Nov 2023, 03:25 PM"
        },
        {
          Id: 6,
          key:6,
          img:img7,
          Name: "Randall ",
          email: "randall@example.com",
          Subscription: "Basic",
          Amount: "$150",
          Durations: "3 Month",
          StartDate: "15 Nov 2022, 03:25 PM",
          EndDate: "18 Nov 2023, 03:25 PM"
        }
       ]
}